/**
 * Strip wrapped quotes from a string
 * @param value value to strip quotes from
 * @return The value without leading or trailing quotes
 *
 * @example
 * ```ts
 * const value = stripWrappedQuotes('"value"'); // value
 * const value = stripWrappedQuotes('value"'); // value
 * const value = stripWrappedQuotes('"value'); // value
 * const value = stripWrappedQuotes('""'); // ""
 * ```
 */
export const stripWrappedQuotes = (value: string) => {
	if (value.length < 2) return value;
	if (value === '""' || value === "''") return value;
	if (value.startsWith('"') || value.startsWith("'")) {
		value = value.slice(1);
	}
	if (value.endsWith('"') || value.endsWith("'")) {
		value = value.slice(0, -1);
	}
	return value;
};
